// extracted by mini-css-extract-plugin
export default {"releasesTable":"WHRTGYK_PnPwlJqMhDlh"};